export function hasActiveTextSelection() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return false;
    }

    const activeElement = document.activeElement;
    const activeTagName = String(activeElement?.tagName || '').toLowerCase();
    if (
        (activeTagName === 'textarea' || activeTagName === 'input')
        && typeof activeElement.selectionStart === 'number'
        && typeof activeElement.selectionEnd === 'number'
        && activeElement.selectionEnd > activeElement.selectionStart
    ) {
        return true;
    }

    const selection = typeof window.getSelection === 'function' ? window.getSelection() : null;
    return Boolean(selection && !selection.isCollapsed && selection.toString().length > 0);
}
